// Error steps (API.md §3.5 `ErrorStep`): stored values and the UI labels (UserFlows C-03; T-C03-02).
export const ERROR_STEPS = ['pf_lookup', 'availability', 'hold', 'pf_write', 'pf_message', 'pf_login'] as const
export type ErrorStep = (typeof ERROR_STEPS)[number]

export const STEP_LABELS: Record<ErrorStep, string> = {
  pf_lookup: 'PF lookup',
  availability: 'Availability',
  hold: 'Hold',
  pf_write: 'PF write',
  /** Task 24: the PF internal message about a new booking (`PF_MESSAGE_FAILED`). */
  pf_message: 'PF message',
  /** Task 25: PF Keeper's login security code (`PF_SECURITY_CODE_FAILED`). */
  pf_login: 'PF login',
}

/** The mockup's step pill colours (`staff.css` `.st-*`). */
export const STEP_CLASS: Record<ErrorStep, string> = {
  pf_lookup: 'st-lookup',
  availability: 'st-avail',
  hold: 'st-hold',
  pf_write: 'st-write',
  pf_message: 'st-message',
  pf_login: 'st-login',
}

export const isErrorStep = (v: unknown): v is ErrorStep => (ERROR_STEPS as readonly unknown[]).includes(v)

export const stepLabel = (step: string): string => (isErrorStep(step) ? STEP_LABELS[step] : step)

/**
 * C-03a's hint for an outcome-unknown booking (Observability §6.6). UserFlows (the copy owner) doesn't list it yet;
 * shown with Observability's wording (task 10 assumption).
 */
export const CODE_HINTS: Record<string, string> = {
  PF_WRITE_UNKNOWN: 'Check PF for an appointment at this slot before rebooking.',
}
